import { Component } from "react"
import PropTypes from "prop-types"

import { genericFilterGroup, createPACTransactionsFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import {
    TransactionTypeFilter,
    TransactionLedgerSettingsFilter,
    TransactionSupporterFilter,
    TransactionOfficialFilter,
    TransactionPublicOrganizationFilter,
    TransactionPoliticalCommitteeFilter,
    TransactionElectionFilter,
    TransactionAccountTypeFilter,
    TransactionAccountTypeSelectFilter,
    TransactionSerialNumberFilter,
    TransactionPACCIdFilter,
    TransactionImportIdFilter,
    TransactionIsVoidFilter,
    TransactionIsVoidDatePickerStartFilter,
    TransactionIsVoidDatePickerEndFilter,
    TransactionIsReconciledFilter,
} from "shared/search/containers/Filter/TransactionFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

// Receipt, Disbursement, Refund, Transfer, etc
export class TransactionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [TransactionTypeFilter],
        uniqueFilterGroupId: "transactionTypeFilterGroup",
        displayLabel: "Type",
        helpText: "Filter transactions by type.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

// Contributions from Individuals, Bank Interest, etc
export class TransactionContributionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [TransactionAccountTypeFilter, TransactionAccountTypeSelectFilter],
        uniqueFilterGroupId: "contributionTypeFilterGroup",
        displayLabel: `${DjangIO.app.models.QuorumDataType.transaction.singular} Type`,
        helpText: "Filter transactions by type.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const TransactionLedgerSettingsFilterGroup = (props) => genericFilterGroup(props)
TransactionLedgerSettingsFilterGroup.propTypes = defaultProps
TransactionLedgerSettingsFilterGroup.defaultProps = {
    filters: [TransactionLedgerSettingsFilter],
    uniqueFilterGroupId: "transactionLedgerSettingsFilterGroup",
    displayLabel: "PAC",
    helpText: "Filter Results by PAC.",
}

export const TransactionSupporterFilterGroup = (props) => genericFilterGroup(props)
TransactionSupporterFilterGroup.propTypes = defaultProps
TransactionSupporterFilterGroup.defaultProps = {
    filters: [TransactionSupporterFilter],
    uniqueFilterGroupId: "transactionSupporterFilterGroup",
    displayLabel: "Contacts",
    helpText: "Filter Results by Contacts.",
}

export const TransactionOfficialFilterGroup = (props) => genericFilterGroup(props)
TransactionOfficialFilterGroup.propTypes = defaultProps
TransactionOfficialFilterGroup.defaultProps = {
    filters: [TransactionOfficialFilter],
    uniqueFilterGroupId: "transactionOfficialFilterGroup",
    displayLabel: "Officials",
    helpText: "Filter Results by Officials.",
}

export const TransactionPublicOrganizationFilterGroup = (props) => genericFilterGroup(props)
TransactionPublicOrganizationFilterGroup.propTypes = defaultProps
TransactionPublicOrganizationFilterGroup.defaultProps = {
    filters: [TransactionPublicOrganizationFilter],
    uniqueFilterGroupId: "transactionPublicOrganizationFilterGroup",
    displayLabel: "Organizations",
    helpText: "Filter Results by PAC organization.",
}

export const TransactionPoliticalCommitteeFilterGroup = (props) => genericFilterGroup(props)
TransactionPoliticalCommitteeFilterGroup.propTypes = defaultProps
TransactionPoliticalCommitteeFilterGroup.defaultProps = {
    filters: [TransactionPoliticalCommitteeFilter],
    uniqueFilterGroupId: "transactionPoliticalCommitteeFilterGroup",
    displayLabel: "Political Committees",
    helpText: "Filter Results by political committee.",
}

export const TransactionDetailsFilterGroup = (props) => genericFilterGroup(props)
TransactionDetailsFilterGroup.propTypes = defaultProps
TransactionDetailsFilterGroup.defaultProps = {
    filters: [
        TransactionSerialNumberFilter,
        TransactionPACCIdFilter,
        TransactionImportIdFilter,
        TransactionIsVoidFilter,
        TransactionIsVoidDatePickerStartFilter,
        TransactionIsVoidDatePickerEndFilter,
        // "this will be added in Q3,
        // so we will not want to display this field in search."
        // https://quorumanalytics.atlassian.net/browse/QPAC-461
        // TransactionIsMemoEntryFilter,
        TransactionIsReconciledFilter,
    ],
    uniqueFilterGroupId: "transactionDetailsFilterGroup",
    displayLabel: "Transaction ID / Void / Reconciled",
    helpText: "Filter Results by transaction id or whether it is void or reconciled",
}

export const TransactionAmountFilterGroup = createPACTransactionsFilterGroup({
    displayLabel: "Amount / Date / Bank / Batch",
    quorumDataType: DjangIO.app.models.QuorumDataType.transaction,
    uniqueFilterGroupId: "transactionAmountFilterGroup",
})

export const TransactionElectionFilterGroup = (props) => genericFilterGroup(props)
TransactionElectionFilterGroup.propTypes = defaultProps
TransactionElectionFilterGroup.defaultProps = {
    filters: [TransactionElectionFilter],
    uniqueFilterGroupId: "transactionElectionFilterGroup",
    displayLabel: "Election",
    helpText: "Filter Results by Election.",
}
